//

import { simplApi } from '../../api/simplApi';
import handleApiError from '../../helpers/handleApiError';

// ------------------------------------
// Constants
// ------------------------------------
export const SUBMIT_SUPPORT_TICKET = 'SUBMIT_SUPPORT_TICKET';

// ------------------------------------
// Actions
// ------------------------------------

export const submitSupportTicket = formData => dispatch => {
  const url = 'support/';

  const options = { method: 'post', body: formData };

  simplApi(url, options)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }

        dispatch(handleApiError(json));
      } else {
        // console.log('successfully submitted form:', json);
      }
    });
};

export const actions = {
  submitSupportTicket,
};

// no state needed yet
const SUPPORT_ACTION_HANDLERS = {};

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {};

export default function supportReducer(state = initialState, action) {
  const handler = SUPPORT_ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/modules/support.js